export default {"src":"/_next/static/media/calendar-days.91a651a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};